import { Component, Input } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IModalOffStreetParkingModel } from '@types-custom/models/ui/modal-off-street-parking-model';

@Component({
  selector: 'cdm-manizales-modal-underground-parking',
  templateUrl: './modal-underground-parking.component.html',
  styleUrls: ['./modal-underground-parking.component.scss'],
})
export class ModalUndergroundParkingComponent {

  @Input() properties: IModalOffStreetParkingModel | undefined;

  Icon = Icon;
}
